/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Distillation_Success_CompletedInputs */



/**
* | output |
* | --- |
* | "Your distillation has been completed." |
*
* @param {Distillation_Success_CompletedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_success_completed = /** @type {((inputs?: Distillation_Success_CompletedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Success_CompletedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Destillation wurde abgeschlossen.")
	return /** @type {LocalizedString} */ ("Your distillation has been completed.")
});